import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/FAQs.module.css';
import ArrowLeft from '../static/img/backArrow.png'

const FAQs = () => {
    const navigate = useNavigate();
    const [openQuestion, setOpenQuestion] = useState(null);
    const [search, setSearch] = useState("");
    useEffect(() => {
        document.title = "FAQs | Jazz ESL";
    }, []);

    const faqs = [
        {
            "question": "How do I get Jazz ESL service?",
            "answer": "You can subscribe to Jazz ESL by visiting the Jazz ESL URL http://lp.jazzesl.com.pk/. One day free trial will be activated. Subscribers will be charged after the expiry of one day free trial."
        },
        {
            "question": "What are the service charges for Jazz ESL?",
            "answer": "Prepaid: Rs 10/- Inclusive of tax daily\nPostpaid: Rs 167+Tax/month"
        },
        {
            "question": "Is Jazz ESL available for Jazz postpaid users?",
            "answer": "Yes, Jazz ESL is available for postpaid users as well."
        },
        {
            "question": "Are there any data charges for using the Jazz ESL application?",
            "answer": "Yes, the data usage charges will be as per network provider price plan or the data bundle charges. The subscription charges are only for the usage of Jazz ESL service."
        },
        {
            "question": "How do the challenges and weekly/daily tournaments work?",
            "answer": "Users can submit the screenshot of the completed challenge in the “Challenges” section. Weekly/daily tournaments are structured competitions where you can test your skills against other players."
        },
        {
            "question": "How do I join a tournament on Jazz ESL?",
            "answer": "To join, visit the Jazz ESL web platform and register for the tournament using your gaming ID and in-game nickname. Once registered, you'll receive an SMS 10 minutes before the tournament with the Room ID, password, and start time."
        },
        {
            "question": "What happens if fewer than 10 players check in?",
            "answer": "A minimum of 10 checked-in players is required for the tournament to proceed."
        },
        {
            "question": "What is Aim Train in Jazz ESL?",
            "answer": "Aim Train is a skill-based shooting game. It features 25 progressive levels that help players improve their aiming skills through objectives like accuracy, headshots, target elimination, and avoiding misses."
        },
        {
            "question": "How often can I play a level in Aim Train?",
            "answer": "Each level can be played once per calendar day. Completing levels earns you progressive credits, which are added to your ESL wallet."
        },
        {
            "question": "How do Daily Streaks work in Jazz ESL?",
            "answer": "Log in to Jazz ESL every day to maintain your streak and earn daily credits. The longer your streak, the higher the rewards, with credits increasing progressively."
        },
        {
            "question": "What happens if I miss a day?",
            "answer": "If you miss a day, your streak resets to Day 1. Streaks can be maintained for up to 30 days before automatically resetting."
        },
        {
            "question": "How do I complete a Daily Task on Jazz ESL?",
            "answer": "Log in daily, choose a task from over 10 popular games, complete it on your mobile or console, take a screenshot as proof, and submit it through the Jazz ESL platform."
        },
        {
            "question": "Can I resubmit the task if I uploaded the wrong screenshot?",
            "answer": "No, task submissions are allowed only once per day. Incorrect or invalid submissions cannot be resubmitted."
        },
        {
            "question": "When are new Daily Tasks available?",
            "answer": "Daily Tasks refresh automatically at the start of each calendar day, bringing you a new challenge to complete."
        },
        {
            "question": "How do I win the reward?",
            "answer": "Completing Daily tasks and winning in tournaments earn you credits that can be redeemed in the “Rewards” section."
        },
        {
            "question": "Can a user subscribe through USSD or SMS?",
            "answer": "Subscription is only possible through the web app."
        },
        {
            "question": "What is the process of un-subscription from Jazz ESL?",
            "answer": "User can unsubscribe from Jazz ESL service using the web app."
        },
        {
            "question": "How can I earn credits on Jazz ESL?",
            "answer": "You can earn credits by fulfilling daily tasks/challenges, completing the levels of Aim Train game, maintaining daily log in streak, and by winning the tournaments. The credits are transferred to your Jazz ESL user account."
        },
        {
            "question": "What rewards can I earn on Jazz ESL?",
            "answer": "Credits in Jazz ESL can be redeemed for PS5, gaming mouse, headsets and keyboards. Credits can also be redeemed for popular gaming currencies like PUBG UC, Fortnite V-bucks, and Minecraft minecoins."
        },
        {
            "question": "Is there a free trial available for Jazz ESL?",
            "answer": "Yes, Jazz ESL offers a one-day free trial upon subscribing, allowing you to explore the platform's features before committing to a paid subscription."
        },
        {
            "question": "Is there an expiry for the earned credits?",
            "answer": "No, users can avail their earned credits for as long as they want."
        },
        {
            "question": "How can I access Jazz ESL support for assistance?",
            "answer": "Jazz ESL's backend support can be reached at support@jazzesl.com.pk"
        },
        {
            "question": "How do I join a Cannon Clash tournament?",
            "answer": "Click \"Join Now\" on the tournament page https://jazzesl.com.pk/tournaments. You will receive an SMS with your Room ID and match time one hour before your match."
        },
        {
            "question": "Do I need to download Cannon Clash to play?",
            "answer": "No, Cannon Clash is played directly on Jazz ESL web page."
        },
        {
            "question": "How do I enter my Cannon Clash match?",
            "answer": "At your allotted time, go to the Cannon Clash web page https://jazzesl.com.pk/tournaments, enter your Room ID from the SMS, and click \"Submit\"."
        },
        {
            "question": "What if my Cannon Clash opponent doesn't join?",
            "answer": "If the opponent does not join before the countdown timer ends, you will automatically be declared the winner."
        },
        {
            "question": "What happens if I miss my Cannon Clash match?",
            "answer": "If you fail to join at your allotted time, you will be considered a no-show and eliminated from the tournament."
        },
        {
            "question": "How do I control my cannon in Cannon Clash?",
            "answer": "Move Cannon: Drag left or right\nFire Minions: Tap/Press the cannon"
        },
        {
            "question": "How do I win a Cannon Clash match?",
            "answer": "Destroy your opponent's two side towers first. Once both side towers are down, your minions will attack the center tower. The player who destroys the center tower first wins the match."
        },
        {
            "question": "How are Cannon Clash rounds organized?",
            "answer": "The tournament follows a progressive 1v1 knockout format. Winners move on, losers are eliminated."
        },
        {
            "question": "When will the next Cannon Clash round take place?",
            "answer": "The next round will be scheduled on the following day at the same time mentioned on the web. You'll receive another SMS with your Room ID and match time."
        },
        {
            "question": "How many rounds are there in Cannon Clash tournaments?",
            "answer": "The number of rounds depends on the total number of participants. The tournament continues until there is one final winner."
        },
        {
            "question": "What does the Cannon Clash winner get?",
            "answer": "The tournament champion will have their reward instantly credited to their Jazz ESL wallet."
        },
        {
            "question": "Can eliminated players rejoin the same Cannon Clash tournament?",
            "answer": "No. Once you are eliminated, you cannot rejoin the ongoing tournament. You may register for the next tournament."
        }
    ];

    const filteredFaqs = faqs.filter(faq =>
        faq.question.toLowerCase().includes(search.toLowerCase()) ||
        faq.answer.toLowerCase().includes(search.toLowerCase())
    );
    const toggleQuestion = (index) => {
        if (openQuestion === index) {
            setOpenQuestion(null);
        } else {
            setOpenQuestion(index);
        }
    };

    return (
        <div className={styles.container}>

            <div className={styles.navigationHeader}>
                <div
                    className={styles.navigationBack}
                    onClick={() => navigate(-1)}
                >
                    <img src={ArrowLeft} alt="<" />
                </div>
                <div className={styles.navigationTitle}>
                    <p>support</p>
                    <h2 className={styles.heading}>FAQ's</h2>
                </div>
            </div>

            {/* SEARCH */}
            <div className={styles.searchBox}>
                <span className={styles.searchIcon}><img src="/icons/search.png" alt="" /></span>
                <input
                    placeholder="Search help articles..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            {/* SECTION TITLE */}
            <div className={styles.sectionTitle}>FREQUENT QUESTIONS</div>

            {/* FAQ LIST */}
            <div className={styles.faqList}>
                {filteredFaqs.length === 0 && (
                    <div className={styles.noResult}>
                        No results found
                    </div>
                )}
                {filteredFaqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`${styles.faqItem} ${openQuestion === index ? styles.active : ''}`}
                    >
                        <div
                            className={styles.question}
                            onClick={() => toggleQuestion(index)}
                        >
                            <span>{faq.question}</span>
                            <span className={styles.chevron}>
                                {openQuestion === index ? '⌃' : '⌄'}
                            </span>
                        </div>

                        {openQuestion === index && (
                            <div className={styles.answer}>
                                {faq.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* CONTACT SUPPORT */}
            <div className={styles.contactBtn}>
                <img src="/icons/chat.png" alt="" /> CONTACT SUPPORT
            </div>

        </div>
    );
};

export default FAQs; 